/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 200 ok object
 * @export
 * @interface GetUniverseSystemJumps200Ok
 */
export interface GetUniverseSystemJumps200Ok {
    /**
     * ship_jumps integer
     * @type {number}
     * @memberof GetUniverseSystemJumps200Ok
     */
    shipJumps: number;
    /**
     * system_id integer
     * @type {number}
     * @memberof GetUniverseSystemJumps200Ok
     */
    systemId: number;
}

/**
 * Check if a given object implements the GetUniverseSystemJumps200Ok interface.
 */
export function instanceOfGetUniverseSystemJumps200Ok(value: object): value is GetUniverseSystemJumps200Ok {
    if (!('shipJumps' in value) || value['shipJumps'] === undefined) return false;
    if (!('systemId' in value) || value['systemId'] === undefined) return false;
    return true;
}

export function GetUniverseSystemJumps200OkFromJSON(json: any): GetUniverseSystemJumps200Ok {
    return GetUniverseSystemJumps200OkFromJSONTyped(json, false);
}

export function GetUniverseSystemJumps200OkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUniverseSystemJumps200Ok {
    if (json == null) {
        return json;
    }
    return {
        
        'shipJumps': json['ship_jumps'],
        'systemId': json['system_id'],
    };
}

export function GetUniverseSystemJumps200OkToJSON(json: any): GetUniverseSystemJumps200Ok {
    return GetUniverseSystemJumps200OkToJSONTyped(json, false);
}

export function GetUniverseSystemJumps200OkToJSONTyped(value?: GetUniverseSystemJumps200Ok | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ship_jumps': value['shipJumps'],
        'system_id': value['systemId'],
    };
}

